"use strict";

var _slicedToArray = require("/home/jenkins/workspace/roar-the-new-roar-ECS-Prod-2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/jenkins/workspace/roar-the-new-roar-ECS-Prod-2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var cars = require("../../../fixtures/regexes/device/car_browsers.json");

var CarParser = function CarParser() {
  _classCallCheck(this, CarParser);

  this.parse = function (userAgent) {
    var result = {
      type: "",
      brand: "",
      model: ""
    };

    for (var _i = 0, _Object$entries = Object.entries(cars); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          brand = _Object$entries$_i[0],
          car = _Object$entries$_i[1];

      var match = user_agent_1.userAgentParser(car.regex, userAgent);
      if (!match) continue;
      result.type = "car";
      result.brand = brand;

      if (car.model) {
        result.model = variable_replacement_1.variableReplacement(car.model, match).trim();
      }

      break;
    }

    return result;
  };
};

exports.default = CarParser;